
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { fields, InstrumentData, Option, statuses } from '../fields'

@Component
export default class InstrumentForm extends Vue {
  @Prop({ required: true }) readonly value!: InstrumentData
  @Prop({ default: () => [] }) readonly departments!: Option[]
  @Prop({ default: () => [] }) readonly persons!: Option[]
  @Prop({ default: () => [] }) readonly classifications!: string[]
  @Prop({ default: () => [] }) readonly assetNatures!: string[]
  @Prop({ default: false }) readonly disabled!: boolean
  fields = fields

  get rules() {
    const rules: Record<string, any[]> = {}
    fields.filter(field => field.required).forEach(field => {
      rules[field.key] = [{ required: true, message: `请填写${field.label}`, trigger: ['blur', 'change'] }]
    })
    return rules
  }

  options(type: string): Option[] {
    if (type === 'department') return this.departments
    if (type === 'person') return this.persons
    return statuses
  }

  setField(key: string, value: any) {
    this.$emit('input', { ...this.value, [key]: value })
  }

  validate(changedFields?: string[]): Promise<boolean> {
    const form = this.$refs.form as ElForm
    if (!changedFields) return new Promise(resolve => form.validate(valid => resolve(valid)))
    return Promise.all(changedFields.map(field => new Promise<boolean>(resolve => {
      form.validateField(field, error => resolve(!error))
    }))).then(results => results.every(Boolean))
  }
}
